import React, { FC, useState } from "react";
import {
  Modal,
  ModalActions,
  ModalContent,
  ModalContentText,
  ModalTitle,
} from "@carrier-io/air-react";
import Button from "@carrier-io/air-react/Button";
import FormControlLabel from "@carrier-io/air-react/FormControlLabel";
import Checkbox from "@carrier-io/air-react/Checkbox";

export type ConfirmDeactivationPopupProps = {
  opened: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ConfirmDeactivationPopup: FC<ConfirmDeactivationPopupProps> = ({
  opened,
  onCancel,
  onConfirm,
}) => {
  const [allowDeactivation, setAllowDeactivation] = useState(false);

  const handleConfirm = () => {
    onConfirm();
    setAllowDeactivation(false);
  };

  const handleCancel = () => {
    onCancel();
    setAllowDeactivation(false);
  };

  return (
    <Modal maxWidth="sm" fullWidth open={opened} scroll="paper">
      <>
        <ModalTitle
          data-testid="confirmation-title"
          clearable
          onClose={handleCancel}
          sx={{ padding: "24px 24px 16px 24px !important", height: "28px" }}
        >
          User Deactivation
        </ModalTitle>
        <ModalContent sx={{ padding: "16px 24px 0px 24px !important" }}>
          <ModalContentText
            data-testid="confirmation-content"
            sx={{ paddingBottom: 1 }}
          >
            Are you sure you want to deactivate this user?
          </ModalContentText>
          <FormControlLabel
            control={
              <Checkbox
                data-testid="allow-deactivation-checkbox"
                color="base"
                checked={allowDeactivation}
                onChange={(_, checked) => setAllowDeactivation(checked)}
              />
            }
            sx={{ marginLeft: 0 }}
            label="Yes. Deactivate this user."
            labelPlacement="end"
          />
        </ModalContent>
        <ModalActions sx={{ padding: "24px" }}>
          <Button
            data-testid="confirmation-cancel"
            color="secondary"
            onClick={handleCancel}
            variant="text"
          >
            Cancel
          </Button>
          <Button
            data-testid="confirmation-yes"
            disabled={!allowDeactivation}
            onClick={handleConfirm}
            variant="outlined"
          >
            Confirm Deactivation
          </Button>
        </ModalActions>
      </>
    </Modal>
  );
};
